<template>
  <div class="layout">
    <webhead></webhead>
    <div class="main">
      <router-view></router-view>
    </div>
    <foot></foot>
  </div>
</template>

<script>
import Head from '../components/Head.vue'
import Foot from '../components/Foot.vue'

export default {
  components: {
    webhead: Head,
    Foot
  }
}
</script>
<style lang="less" scoped>
  .layout {
    width: 100%;
    height: 100vh;
    padding-top: 60px;
  }
  .main {
    min-height: calc(100vh - 150px);
    padding: 24px;
    overflow: scroll;
  }
</style>
